import { Button, Result } from "antd";
import React from "react";
import { logout } from "@utils/logout";
import { useNavigate } from "react-router-dom";

const OtherErrors = () => {
  const navigate = useNavigate();
  const isOnline = navigator.onLine;
  if(isOnline) return (
    <Result
      status="warning"
      title="متاسفانه خطای نا مشخصی رخ داده!!! لطفا با مدیریت تماس بگیرید."
      extra={
        <>
          <Button key="logout" type="secondary" onClick={logout}>
            خروج
          </Button>
          <Button type="primary" onClick={() => navigate(-1)}>
            تلاش مجدد
          </Button>
        </>
      }
    />
  );
else return (
    <Result
    status={500}
      title="عدم اتصال به اینترنت"
      subTitle="به نظر میرسه اتصال اینترنت شما قطع شده!!!"
      extra={
        <Button type="primary" onClick={() => window.location.reload()} >
          بارگذاری
        </Button>
      }
    />
  );
};
export default OtherErrors;
